/*
 *
 * GoogleCalendarManager actions
 *
 */

import {
	FETCH_CALENDARS_REQUEST,
	FETCH_CALENDARS_SUCCESS,
	FETCH_CALENDARS_FAILURE,
	DELETE_CALENDAR_REQUEST,
	DELETE_CALENDAR_SUCCESS,
	DELETE_CALENDAR_FAILURE,
	CANCEL_FETCH_CALENDARS,
} from './constants';

export function fetchCalendars() {
	return {
		type: FETCH_CALENDARS_REQUEST,
	};
}

export function fetchCalendarsSuccess(calendars) {
	return {
		type: FETCH_CALENDARS_SUCCESS,
		calendars,
	};
}

export function fetchCalendarsFailure(error) {
	return {
		type: FETCH_CALENDARS_FAILURE,
		error,
	};
}

export function deleteCalendar(calendarId) {
	return {
		type: DELETE_CALENDAR_REQUEST,
		calendarId,
	};
}

export function deleteCalendarSuccess(calendarId) {
	return {
		type: DELETE_CALENDAR_SUCCESS,
		calendarId,
	};
}

export function deleteCalendarFailure(error) {
	return {
		type: DELETE_CALENDAR_FAILURE,
		error,
	};
}

export function cancelFetchCalendars() {
	return {
		type: CANCEL_FETCH_CALENDARS,
	};
}
